import type { BookingSummary } from "@apartos/contracts";

const sourceMeta = {
  booking: ["Booking.com", "source-booking"],
  airbnb: ["Airbnb", "source-airbnb"],
  website: ["Сайт", "source-website"],
  telegram: ["Telegram", "source-telegram"],
  whatsapp: ["WhatsApp", "source-whatsapp"],
  phone: ["Телефон", "source-phone"],
  reception: ["Ресепшн", "source-reception"],
  travel_agency: ["Турагентство", "source-reception"],
} as const;

export function BookingChannelMark({ compact = false }: { compact?: boolean }) {
  return <span className={`booking-channel-mark ${compact ? "is-compact" : ""}`} aria-label="Booking.com" title="Booking.com">B.</span>;
}

export function BookingSourceBadge({ source }: { source: BookingSummary["source"] }) {
  const [label, sourceClass] = sourceMeta[source];
  return <span className={`source-badge ${sourceClass}`}>
    {source === "booking" && <BookingChannelMark compact />}
    <span>{label}</span>
  </span>;
}
